import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const getPermissions = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getPermissionsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/security/permissions',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getPermissionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getPermissionsFailure(err));
      });
  };
};

export const clearPermissionsError = () => {
  return {
    type: Constants.PERMISSIONS_CLEAR_ERROR
  };
};

const getPermissionsRequest = () => {
  return {
    type: Constants.PERMISSIONS_GET_REQUEST
  };
};

const getPermissionsSuccess = data => {
  return {
    type: Constants.PERMISSIONS_GET_SUCCESS,
    payload: data
  };
};

const getPermissionsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PERMISSIONS_GET_FAILURE,
    payload
  };
};
